import type { IToastConfig } from 'src/common/primitives/Toast';

export function generateSuccessToast(nickname: string): IToastConfig {
  return {
    title: nickname
      ? `Successfully added vehicle: ${nickname}`
      : `Successfully added a vehicle`,
  };
}
